import { Icon } from '../../design-system/Icon'
import React from 'react'
import { DSColor, PlayingStyle } from '@ppwr/poker'
import { formatShortMonthAndDate, formatTimePicker } from '../../utils'

export function mapPlayingStyleIcon(playingStyle: PlayingStyle, color: DSColor = 'Brand/Dark Grey') {
  switch (playingStyle) {
    case 'Tight-Aggressive':
      return <Icon name="Shield" size={32} color={color} />
    case 'Loose-Aggressive':
      return <Icon name="Flame" size={32} color={color} />
    case 'Loose-Passive':
      return <Icon name="Turtle" size={32} color={color} />
    case 'Tight-Passive':
      return <Icon name="Shell" size={32} color={color} />
    default:
      return <Icon name="YinYang" size={32} color={color} />
  }
}

export function mapPlayingStyleDescription(playingStyle: PlayingStyle): string {
  switch (playingStyle) {
    case 'Tight-Aggressive':
      return 'Disciplined and strategic, you play strong hands and push aggressively. You’re cautious but attack when it counts. Solid and reliable.'
    case 'Loose-Aggressive':
      return 'Bold and unpredictable, you play many hands, keeping opponents guessing. You take risks and excel at extracting value post-flop.'
    case 'Loose-Passive':
      return 'Curious and active, but calling too much hurts your win rate. Convert those calls into strategic raises to level up your game.'
    case 'Tight-Passive':
      return 'Selective and cautious, you play strong hands but lack aggression. Add more bold moves to turn good hands into big wins.'
    default:
      return 'Versatile and adaptable, you shift strategies based on the table, making you unpredictable and hard to outplay. Keep opponents guessing.'
  }
}

export function parseDateStart(gameStartTime: number | undefined) {
  if (!gameStartTime) {
    return ''
  }
  return `${formatShortMonthAndDate(new Date(gameStartTime))}, ${formatTimePicker(new Date(gameStartTime))}`
}
